import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Button } from "react-bootstrap";

import { TRANSLATIONS as translation } from "../../../../../../utils/constant.utils";
import { BillingAccountAction } from "../../../../../../store/external/finance/billing-account/billing-account-details.reducer";
import { NotificationModal } from "../../../../../common/modal/notification-modal.component";
import { ConfirmationModal } from "../../../../../common/modal/modal.component";
import BillingCostAllocation from "./cost-allocation-form/cost-allocation-form.component";
import BillingAddPurchaseOrder from "./add-purchase-order/billing-add-purchase-order.component";
import BillingLocationDetails from "../billing-account-details/billing-account-locations/billing-account-locations.component";
import BillingTransactionDetails from "./billing-transaction-details/billing-transaction-details.component";
import { NoSubscription } from "../../../../dashboard/no-subscription/no-subscription.component";
import { inventoryCostAllocationActions } from "../../../../../../store/external/inventory/add-cost-allocation.reducer";
import { JsonHubProtocol } from "@microsoft/signalr";
import { isObjectEqual, areDataEqual } from "../../../../../../utils/helpers.utils";

class BillingAccountDetails extends Component {
    constructor(props) {
        super(props);
        this.ConfirmationModal = React.createRef();
        this.state = {
            activeDropdown: 0,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            accountNumAlreadyExist: false,
            isLoading: true,
            costAllocationData: [],
            purchaseOrderData: [],
            originalBillingCostAllocationData: [],
            originalPurchaseOrderData: [],
            selectedBillingAccount: this.props.selectedBillingAccount,
            isSaving: false,
            tableData: [
                {
                    dataItem: [
                    ],
                    HeaderItem: [
                        {
                            CostAllocationID: {
                                propName: "CostAllocationID",
                                name: "CostAllocationID",
                                hidden: true,
                            },
                            GLCode: {
                                propName: "GLCode",
                                name: "GL Code",
                                hidden: false,
                            },
                            GLCodeName: {
                                propName: "GLCodeName",
                                name: "Name",
                                hidden: false,
                            },
                            CostCode: {
                                propName: "CostCode",
                                name: "Cost Center",
                                hidden: false,
                            },
                            CompanyCode: {
                                propName: "CompanyCode",
                                name: "Company Code",
                                hidden: false,
                            },
                            CostCodePercent: {
                                propName: "CostCodePercent",
                                name: "Percent",
                                hidden: false,
                            },
                            LastModified: {
                                propName: "LastModified",
                                name: "Last Modified",
                                hidden: false,
                            },
                        },
                    ],
                },
            ],
            costAllocationfieldType: [{
                name: 'GLCode',
                type: 'searchabledropdown',
                selected: 'GLCodeID',
                labelSelected: 'GLCodeName',
                required: true,
                data: [
                    {
                        "Key": 2,
                        "Value": "GL_2",
                        "Label": "GL Two"
                    },
                    {
                        "Key": 3,
                        "Value": "GL_3",
                        "Label": "GL Three"
                    },
                    {
                        "Key": 4,
                        "Value": "GL_4",
                        "Label": "GL Four"
                    },
                    {
                        "Key": 5,
                        "Value": "GL_5",
                        "Label": "GL Five"
                    },
                    {
                        "Key": 6,
                        "Value": "GL_6",
                        "Label": "GL Six"
                    },
                    {
                        "Key": 7,
                        "Value": "GL_7",
                        "Label": "GL Seven"
                    }]
            }, {
                name: 'CostCode',
                type: 'searchabledropdown',
                selected: 'CostCodeID',
                labelSelected: 'CompanyCode',
                data: [
                    {
                        "Key": 286,
                        "Value": "0198",
                        "Label": "0198"
                    },
                    {
                        "Key": 287,
                        "Value": "Cost_Center_3",
                        "Label": "Cost Center 3"
                    },
                    {
                        "Key": 289,
                        "Value": "Cost_Center_4",
                        "Label": "Cost Center 4"
                    },
                    {
                        "Key": 290,
                        "Value": "Cost_Center_5",
                        "Label": "Cost Center 5"
                    },
                    {
                        "Key": 291,
                        "Value": "Cost_Center_6",
                        "Label": "Cost Center 6"
                    },
                    {
                        "Key": 291,
                        "Value": "Cost_Center_7",
                        "Label": "Cost Center 7"
                    }]

            }, {
                name: 'CostCodePercent',
                type: 'number',
                numberType: 'decimal',
                required: true
            }],
            purchaseOrder: [
                {
                    dataItem: [
                    ],
                    HeaderItem: [
                        {
                            PoNumber: {
                                propName: "PoNumber",
                                name: "PO Number",
                                hidden: false,
                            },
                            PoValue: {
                                propName: "PoValue",
                                name: "PO Value",
                                hidden: false,
                            },
                            ValidFrom: {
                                propName: "ValidFrom",
                                name: "Validate From",
                                hidden: false,
                            },
                            ValidTo: {
                                propName: "ValidTo",
                                name: "Validate To",
                                hidden: false,
                            }
                        },
                    ],
                },
            ],
        }
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        const { getBillingAccountDetailsForm, getActiveVendors, getAccountType, getAccountStatus, getAccountFirstBill, getAllocationLevel,
            getAccountInterval, getAllAddressLocation1, getAllAddressLocation2, financeAccountId, getBillingAccountCostAllocation, isCreateNew, resetBillingAccountForm,
            getAccountPurchaseOrder } = this.props
       
        getAccountType();
        getAccountStatus();
        getAccountFirstBill();
        getAllocationLevel();
        getAccountInterval();
        getAllAddressLocation1(1, this.state.selectedBillingAccount?.LocationBillingSiteID);
        getAllAddressLocation2(1, this.state.selectedBillingAccount?.LocationRemitSiteID);

        if (financeAccountId && !isCreateNew) {
            const vendorName = await getBillingAccountDetailsForm(financeAccountId);
             getActiveVendors(1, vendorName);


            await getBillingAccountCostAllocation(financeAccountId)

            await getAccountPurchaseOrder(financeAccountId).then(() => {
                const dataItem = this.props.billingAccountDetails.accountPurchaseOrder?.dataTable?.[0]?.dataItem;
                const originalPurchaseOrderDataCopy = dataItem ? JSON.parse(JSON.stringify(dataItem)) : [];
                this.setState({ originalPurchaseOrderData: originalPurchaseOrderDataCopy, purchaseOrderData: [...originalPurchaseOrderDataCopy], isLoading: false })
            })
            const dataItem = this.props.inventoryCostAllocation.circuitCostAllocation?.datatable?.[0]?.dataItem;
            const originalBillingCostAllocationDataCopy = dataItem ? JSON.parse(JSON.stringify(dataItem)) : [];
            this.setState({ originalBillingCostAllocationData: originalBillingCostAllocationDataCopy })
            this.setState({ isLoading: false });
        }

        if (isCreateNew) {
            resetBillingAccountForm();
            this.setState({ isLoading: false });
             getActiveVendors();
        }
    }

    handleLoadMoreVendors = (page, searchString) => {
        this.props.getActiveVendors(page, searchString);
    }

    handleLoadMoreContracts = (page, searchString) => {
        const { vendorDetailId } = this.props.billingAccountForm.billingAccount
        this.props.fetchFinanceContractbyVendor(page, searchString, vendorDetailId);
    }

    handleLoadMoreAPVendor = (page, searchString) => {
        const { vendorDetailId } = this.props.billingAccountForm.billingAccount
        this.props.fetchAPVendorsbyVendor(page, searchString, vendorDetailId);
    }

    handleSearchActiveVendors = (query) => {
        this.props.getActiveVendors(1, query);
    }

    handleSearchContractID = (query) => {
        this.props.fetchFinanceContractbyVendor(1, query);
    }

    handleSearchAPVendors = (query) => {
        this.props.fetchAPVendorsbyVendor(1, query);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.billingAccountForm.billingAccount.billingAccountNumber !== this.props.billingAccountForm.billingAccount.billingAccountNumber) {
            this.setState({ accountNumAlreadyExist: false })
        }
    }

    handleButtonConfirmation = async (financeAccountId = 0, validate = 1) => {
        const { saveBillingAccount, isCreateNew, inventoryCostAllocation, billingAccountDetails, getBillingAccountCostAllocation, getAccountPurchaseOrder, getAllAddressLocation1, getAllAddressLocation2, billingAccountForm } = this.props;
        const { costAllocationData, purchaseOrderData } = this.state;

        const actualCostAllocData = costAllocationData?.[0] ??
            inventoryCostAllocation?.circuitCostAllocation?.datatable?.[0]?.dataItem;

        const actualPurchaseOrdData = purchaseOrderData ??
            billingAccountDetails?.accountPurchaseOrder?.dataTable?.[0]?.dataItem;

        if (isCreateNew) {
            this.setState({
                isSaving: true
            });
        }

        var result = await saveBillingAccount(financeAccountId, validate, actualCostAllocData, actualPurchaseOrdData);

        if (result.success === false) {

            if (result.isValid) {
                if (!isCreateNew) {
                    const confirmMessage = this.toLocaleLanguage("save_confirmation");
                    const modalTitle = this.toLocaleLanguage("call_save");
                    var confirmAction = () => this.handleButtonConfirmation(financeAccountId, 0);
                    this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                    return;
                }
                else {
                    this.handleButtonConfirmation(financeAccountId, 0);
                    return;
                }
            } else {
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
                if (result.message === "Account Number already exist on the Vendor.") {
                    this.setState({ accountNumAlreadyExist: true })
                }
                return;
            }
        }
        else if (result.success === true) {
            await getBillingAccountCostAllocation(financeAccountId);
            const purchaseOrderRes = await getAccountPurchaseOrder(financeAccountId);
            const latestPurchaseOrderData = purchaseOrderRes?.dataTable?.[0]?.dataItem ?? [];

            this.setState({
                originalBillingCostAllocationData: costAllocationData
                , originalPurchaseOrderData: latestPurchaseOrderData,
                purchaseOrderData: latestPurchaseOrderData
            });

            const modalMessage = isCreateNew ? this.toLocaleLanguage("billing_account_created") : this.toLocaleLanguage("billing_account_updated");
            const modalTitle = this.toLocaleLanguage("success_modal_title");

            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, modalTitle, modalMessage);
            this.setState({
                accountNumAlreadyExist: false
                ,isSaving: false
            })
            return;
        }
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    toggleSaveNotif = async (isShow, title, message) => {
        const { saveNotif } = this.state;
        const { handleCloseForm, getBillingAccount, resetBillingAccountForm, getBillingAccountDetailsForm, financeAccountId } = this.props

        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

        if (!isShow && saveNotif.message === this.toLocaleLanguage("billing_account_created")) {
            handleCloseForm();
            getBillingAccount();
            resetBillingAccountForm();
        }
        if (!isShow && saveNotif.message === this.toLocaleLanguage("billing_account_updated")) {
            getBillingAccountDetailsForm(financeAccountId);
            getBillingAccount();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleFetchCostAllocationData = async (data) => {
        const { getBillingAccountCostAllocation, financeAccountId, inventoryCostAllocation } = this.props;

        await getBillingAccountCostAllocation(financeAccountId);
        const origCostAllocation = inventoryCostAllocation?.circuitCostAllocation?.datatable?.[0]?.dataItem;

        this.setState({
            costAllocationData: data,
            originalBillingCostAllocationData: origCostAllocation
        });
    };

    handleFetchPurchaseOrder = async (data) => {
        const safeData = data ?? [];
        const [item] = safeData;

        this.setState({
            purchaseOrderData: Array.isArray(item) ? item : safeData
        });
    }

    disableSaveChanges = () => {
        const { $form, billingAccountForm } = this.props
        const { billingAccount, billingAddress, remitAddress } = billingAccountForm;
        const { vendorDetailId, accountTypeId, billingAccountNumber, accountStatusId, invoiceFormat, invoiceReceiptDate,
            accountIntervalId, accountFirstBillId, allocationLevelId, clientName, takeOverdate } = billingAccount

        const isFieldEmpty = !vendorDetailId || !accountTypeId || !billingAccountNumber || !accountStatusId || !invoiceFormat ||
            !invoiceReceiptDate || !accountIntervalId || !accountFirstBillId || !allocationLevelId || !clientName
            || !takeOverdate;

        if (isFieldEmpty) {
            return true;
        }
        var updatedPurchaseOrderData = [];
        if (Array.isArray(this.state.purchaseOrderData[0])) {
            updatedPurchaseOrderData = [...this.state.purchaseOrderData[0]]
        } else {
            updatedPurchaseOrderData = [...this.state.purchaseOrderData]
        }

        var updatedCostAllocation = [];
        if (Array.isArray(this.state.costAllocationData[0])) {
            updatedCostAllocation = [...this.state.costAllocationData[0]]
        } else {
            updatedCostAllocation = [...this.state.originalBillingCostAllocationData]
        }

        var updatedOrigCostAllocData = [];
        if (Array.isArray(this.state.originalBillingCostAllocationData[0])) {
            updatedOrigCostAllocData = [...this.state.originalBillingCostAllocationData[0]]
        } else {
            updatedOrigCostAllocData = [...this.state.originalBillingCostAllocationData]
        }

        var updatedOrigPurchaseOrderData = [];
        if (Array.isArray(this.state.originalPurchaseOrderData[0])) {
            updatedOrigPurchaseOrderData = [...this.state.originalPurchaseOrderData[0]]
        } else {
            updatedOrigPurchaseOrderData = [...this.state.originalPurchaseOrderData]

        }
        const unchangedBillingAccountDetails = !$form.loadedValue ? true : isObjectEqual($form.loadedValue.billingAccount, billingAccount);
        const unchangedBillingLocation = !$form.loadedValue ? true : isObjectEqual($form.loadedValue.billingAddress, billingAddress);
        const unchangedRemitLocation = !$form.loadedValue ? true : isObjectEqual($form.loadedValue.remitAddress, remitAddress);

        const billingAllocationData = this.props.inventoryCostAllocation.circuitCostAllocation.datatable.length > 0
            ? areDataEqual(updatedOrigCostAllocData, updatedCostAllocation)
            : true;

        const purchaseOrderData = areDataEqual(updatedOrigPurchaseOrderData, updatedPurchaseOrderData);

        return unchangedBillingAccountDetails && unchangedBillingLocation && unchangedRemitLocation && billingAllocationData && purchaseOrderData;
    }

    handleLocationSearch1 = (query) => {
        this.props.getAllAddressLocation1(1, query);
    }

    handleLocationSearch2 = (query) => {
        this.props.getAllAddressLocation2(1, query);
    }

    loadMoreLocation1 = (searchString) => {
        const { locationPage1 } = this.props.billingAccountDetails;
        this.props.getAllAddressLocation1(locationPage1 + 1, searchString);
    }

    loadMoreLocation2 = (searchString) => {
        const { locationPage2 } = this.props.billingAccountDetails;
        this.props.getAllAddressLocation2(locationPage2 + 1, searchString);
    }

    render() {

        const { allAddressLocation1, allAddressLocation2, hasMoreLocation1, hasMoreLocation2, isLocationLoading } = this.props.billingAccountDetails;

        const { selectLocation, billingAccountForm, isCreateNew, financeAccountId, resetBillingAddress, isReadAndWrite } = this.props;

        const { vendorDetailId, accountTypeId, billingAccountNumber, accountStatusId, invoiceFormat,
            invoiceReceiptDate, accountIntervalId, accountFirstBillId, allocationLevelId, clientName,
            takeOverdate, masterAccountId } = billingAccountForm.billingAccount

        const requiredFields = [
            vendorDetailId,
            accountTypeId,
            billingAccountNumber,
            accountStatusId,
            invoiceFormat,
            invoiceReceiptDate,
            accountIntervalId,
            accountFirstBillId,
            allocationLevelId,
            clientName,
            takeOverdate,
        ];

        var isMasterAccount = accountTypeId === "3" ? !masterAccountId : false;
        const enableSaveButton = requiredFields.some((field) => !field) || isMasterAccount || this.state.isSaving;
        const { isLoading, accountNumAlreadyExist, selectedBillingAccount } = this.state;

        return (
            <>
                {isLoading ?
                    <NoSubscription /> :
                    <>
                        <div className="data-form-list__container inventory-details-field-container">
                            <BillingTransactionDetails
                                billingAccountDetails={this.props}
                                toLocaleLanguage={this.toLocaleLanguage}
                                isCreateNew={this.props.isCreateNew}
                                selectVendorId={this.props.selectVendorId}
                                selectedContractId={this.props.selectedContractId}
                                selectedApVendor={this.props.selectedApVendor}
                                resetVendorField={this.props.resetVendorField}
                                resetContractField={this.props.resetContractField}
                                accountNumAlreadyExist={accountNumAlreadyExist}
                                onScrollVendors={this.handleLoadMoreVendors}
                                onScrollContract={this.handleLoadMoreContracts}
                                onScrollApVendors={this.handleLoadMoreAPVendor}
                                onSearchActiveVendors={this.handleSearchActiveVendors}
                                onSearchContractID={this.handleSearchContractID}
                                onSearchAPVendors={this.handleSearchAPVendors}
                                fetchFinanceContractbyVendor={this.props.fetchFinanceContractbyVendor}
                                fetchAPVendorsbyVendor={this.props.fetchAPVendorsbyVendor}
                                selectedBillingAccount={selectedBillingAccount}
                            />
                            <BillingLocationDetails
                                allAddressLocation1={allAddressLocation1}
                                allAddressLocation2={allAddressLocation2}
                                selectLocation={selectLocation}
                                resetBillingAddress={resetBillingAddress}
                                handleLocationSearch1={this.handleLocationSearch1}
                                handleLocationSearch2={this.handleLocationSearch2}
                                loadMoreLocation1={this.loadMoreLocation1}
                                loadMoreLocation2={this.loadMoreLocation2}
                                hasMoreLocation1={hasMoreLocation1}
                                hasMoreLocation2={hasMoreLocation2}
                                isLocationLoading={isLocationLoading}
                            />
                            <BillingCostAllocation
                                tableData={this.state.tableData}
                                fieldType={this.state.costAllocationfieldType}
                                handleFetchCostAllocationData={this.handleFetchCostAllocationData}
                                financeId={financeAccountId}
                                isReadOnly={this.props.isReadOnly}
                                isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                                isReadAndWrite={this.props.isReadAndWrite}
                            />
                            <BillingAddPurchaseOrder
                                data={this.state.purchaseOrder}
                                fieldType={this.state.addPurchaseField}
                                handleFetchPurchaseOrder={this.handleFetchPurchaseOrder}
                                financeId={financeAccountId}
                                isReadOnly={this.props.isReadOnly}
                                isReadAndExtractOnly={this.props.isReadAndExtractOnly}
                                isReadAndWrite={this.props.isReadAndWrite}
                            />

                            <div className='dispute-save-btn save-btn-container'>
                                <ConfirmationModal
                                    ref={this.ConfirmationModal}
                                    title={this.state.saveModal.title}
                                    messageBody={this.state.saveModal.messageBody}
                                    confirmAction={this.state.saveModal.confirmAction}
                                    closeLabel={this.toLocaleLanguage("cancel_button", false)}
                                    confirmLabel={this.toLocaleLanguage("yes_button", false)}
                                    disabled={this.state.isSaving}
                                />

                                <NotificationModal
                                    show={this.state.saveNotif.show}
                                    title={this.state.saveNotif.title}
                                    message={this.state.saveNotif.message}
                                    handleModal={() => this.toggleSaveNotif(false)}
                                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                                />
                            </div>
                        </div>
                        <div className="save-btn-container">
                            <div className="tooltip-container">
                                <div className="btn-tooltiptext">
                                    {isReadAndWrite ?
                                        <Button
                                            className='save-details-btn btn btn-primary'
                                            disabled={isCreateNew ? enableSaveButton : this.disableSaveChanges()}
                                            type="button"
                                            onClick={() => this.handleButtonConfirmation(financeAccountId)}>
                                            Save Changes
                                        </Button> : null}
                                    <div className="save-tooltip-text-container">
                                        <span className="tooltip-text-save">{this.toLocaleLanguage("save_billing_account_details")}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </>
        )
    }
}


export default withRouter(
    connect(
        state => {
            const { translation, billingAccountDetails, inventoryCostAllocation } = state;
            const { billingAccountForm, accountLocationForm, forms: { billingAccountForm: { $form } } } = state.form

            return {
                ...translation
                , billingAccountDetails
                , billingAccountForm
                , accountLocationForm
                , inventoryCostAllocation
                , $form
            };
        },
        dispatch => ({
            ...bindActionCreators(
                Object.assign({}
                    , BillingAccountAction
                    , inventoryCostAllocationActions),
                dispatch
            ),
        })
    )(BillingAccountDetails)
);